// Cennik - structured pricing data for Feniks Gastro AGD
export const PRICING_CATEGORIES = [
  {
    id: "diagnostyka",
    title: "Dojazd i diagnostyka",
    icon: "Compass",
    items: [
      { service: "Dojazd i diagnostyka AGD — Katowice", price: "150 zł" },
      { service: "Dojazd i diagnostyka AGD — poza Katowicami", price: "200 zł" },
      { service: "Dojazd i diagnostyka sprzętu gastronomicznego", price: "300 zł" },
    ],
  },
  {
    id: "pralki",
    title: "Pralki",
    icon: "Waves",
    items: [
      { service: "Wymiana pompy spustowej", price: "300 zł" },
      { service: "Wymiana grzałki", price: "300 zł" },
      { service: "Wymiana elektrozaworu", price: "250 zł" },
      { service: "Wymiana fartucha", price: "350 zł" },
      { service: "Wymiana zamka / uchwytu", price: "250 zł" },
    ],
  },
  {
    id: "zmywarki",
    title: "Zmywarki",
    icon: "Droplets",
    items: [
      { service: "Wymiana pompy myjącej", price: "450 zł" },
      { service: "Wymiana grzałki", price: "350 zł" },
      { service: "Wymiana pompy spustowej", price: "350 zł" },
      { service: "Czyszczenie", price: "350 zł" },
      { service: "Demontaż / montaż z mebli", price: "150 zł" },
    ],
  },
  {
    id: "piekarniki",
    title: "Piekarniki",
    icon: "Flame",
    items: [
      { service: "Wymiana termostatu", price: "300 zł" },
      { service: "Wymiana grzałki", price: "300 zł" },
      { service: "Wymiana zegara / programatora", price: "250 zł" },
      { service: "Wymiana przełącznika funkcji", price: "350 zł" },
      { service: "Wymiana szyby", price: "300 zł" },
      { service: "Demontaż / montaż z mebli", price: "100 zł" },
    ],
  },
  {
    id: "suszarki",
    title: "Suszarki",
    icon: "Wind",
    items: [
      { service: "Wymiana pompy spustowej", price: "400 zł" },
      { service: "Wymiana grzałki", price: "350 zł" },
      { service: "Wymiana blokady", price: "350 zł" },
      { service: "Czyszczenie", price: "wycena po oględzinach" },
    ],
  },
  {
    id: "lodowki",
    title: "Lodówki",
    icon: "Snowflake",
    items: [
      { service: "Wymiana termostatu", price: "300 zł" },
      { service: "Wymiana grzałki No Frost", price: "400 zł" },
      { service: "Rozmrażanie systemu No Frost", price: "400 zł" },
      { service: "Wymiana sprężarki", price: "600 zł" },
      { service: "Czyszczenie / udrażnianie", price: "250 zł" },
    ],
  },
  {
    id: "plyty",
    title: "Płyty indukcyjne / elektryczne",
    icon: "LayoutGrid",
    items: [
      { service: "Demontaż / montaż", price: "150 zł" },
      { service: "Wymiana pola grzejnego", price: "250 zł" },
      { service: "Wymiana szyby", price: "300 zł" },
      { service: "Regeneracja modułu", price: "350 zł" },
    ],
  },
  {
    id: "drobne-agd",
    title: "Drobne AGD",
    icon: "Coffee",
    items: [
      { service: "Naprawa drobnego AGD", price: "wycena po diagnostyce" },
    ],
  },
  {
    id: "wyparzarki",
    title: "Wyparzarki gastronomiczne",
    icon: "Sparkles",
    items: [
      { service: "Wymiana termostatu", price: "430 zł" },
      { service: "Wymiana grzałki wanny", price: "400 zł" },
      { service: "Wymiana grzałki bojlera", price: "500 zł" },
      { service: "Wymiana bojlera (komplet)", price: "800 zł" },
      { service: "Wymiana pompy myjącej", price: "800 zł" },
      { service: "Wymiana pompy spustowej", price: "400 zł" },
    ],
  },
  {
    id: "miksery",
    title: "Miksery KitchenAid",
    icon: "RotateCw",
    items: [
      { service: "Czyszczenie / konserwacja przekładni", price: "350 zł" },
      { service: "Wymiana przekładni", price: "450 zł" },
      { service: "Regeneracja korpusu przekładni", price: "450 zł" },
      { service: "Wymiana przekładni planetarnej", price: "350 zł" },
      { service: "Wymiana szczotek silnika", price: "250 – 450 zł" },
    ],
  },
  {
    id: "maszynki",
    title: "Maszynki do mielenia (typ Wilk)",
    icon: "Cog",
    items: [
      { service: "Czyszczenie / konserwacja", price: "400 zł" },
      { service: "Regeneracja silnika", price: "400 zł" },
      { service: "Wymiana przełączników", price: "350 zł" },
    ],
  },
  {
    id: "szatkownice",
    title: "Szatkownice",
    icon: "Scissors",
    items: [
      { service: "Regeneracja przekładni", price: "500 zł" },
      { service: "Regeneracja silnika", price: "450 zł" },
      { service: "Wymiana czujników klapy", price: "400 zł" },
      { service: "Wymiana przełączników", price: "450 zł" },
    ],
  },
  {
    id: "pakowarki",
    title: "Pakowarki próżniowe",
    icon: "Package",
    items: [
      { service: "Wymiana uszczelki", price: "400 zł" },
      { service: "Czyszczenie / konserwacja pompy", price: "500 zł" },
      { service: "Wymiana elektrozaworu", price: "400 zł" },
    ],
  },
];

// Miasta obsługi - rozmieszczone na stylizowanej mapie (procenty x/y)
export const COVERAGE_CITIES = [
  { name: "Katowice", x: 50, y: 50, primary: true },
  { name: "Mysłowice", x: 60, y: 56 },
  { name: "Sosnowiec", x: 64, y: 44 },
  { name: "Dąbrowa Górnicza", x: 72, y: 36 },
  { name: "Siemianowice Śląskie", x: 52, y: 38 },
  { name: "Wojkowice", x: 68, y: 30 },
  { name: "Psary", x: 75, y: 28 },
  { name: "Sarnów", x: 78, y: 32 },
  { name: "Będzin", x: 66, y: 36 },
  { name: "Czeladź", x: 60, y: 40 },
  { name: "Zabrze", x: 30, y: 42 },
  { name: "Chorzów", x: 42, y: 44 },
  { name: "Bytom", x: 38, y: 34 },
  { name: "Świętochłowice", x: 36, y: 46 },
  { name: "Gliwice", x: 20, y: 48 },
  { name: "Tychy", x: 50, y: 70 },
  { name: "Bieruń", x: 58, y: 76 },
  { name: "Pyskowice", x: 16, y: 38 },
  { name: "Nieborowice", x: 12, y: 52 },
  { name: "Orzesze", x: 38, y: 70 },
  { name: "Mikołów", x: 42, y: 62 },
  { name: "Łaziska Górne", x: 36, y: 66 },
  { name: "Łaziska Średnie", x: 34, y: 64 },
  { name: "Gostyń", x: 40, y: 68 },
  { name: "Imielin", x: 62, y: 70 },
  { name: "Jaworzno", x: 76, y: 56 },
  { name: "Wyry", x: 44, y: 66 },
  { name: "Ruda Śląska", x: 32, y: 48 },
];

export const DEVICE_OPTIONS = [
  "Pralka",
  "Zmywarka",
  "Piekarnik",
  "Suszarka",
  "Lodówka",
  "Płyta indukcyjna / elektryczna",
  "Drobne AGD",
  "Wyparzarka gastronomiczna",
  "Mikser KitchenAid",
  "Maszynka do mielenia",
  "Szatkownica",
  "Pakowarka próżniowa",
  "Inne",
];

export const COMPANY = {
  name: "Feniks Gastro & AGD",
  shortName: "Feniks",
  tagline: "Twój sprzęt jak Fenix powstanie z popiołów",
  phone: "+48 576 500 633",
  phoneRaw: "+48576500633",
  email: "feniksgastroagd@gmail.com",
  address: "ul. Tyska 2, 40-655 Katowice",
  addressShort: "Katowice",
  nip: "6342905598",
  hours: "Pn–Pt 8:00 – 18:00 · Sob 9:00 – 13:00",
  hoursLines: [
    { day: "Poniedziałek – Piątek", time: "8:00 – 18:00" },
    { day: "Sobota", time: "9:00 – 13:00" },
    { day: "Niedziela", time: "Nieczynne" },
  ],
  logo: {
    dark: "/logos/feniks-dark.png",
    light: "/logos/feniks-light.png",
    iconDark: "/logos/feniks-icon-dark.png",
    iconLight: "/logos/feniks-icon-light.png",
  },
};
